import * as yup from 'yup';

export function searchInputValidationSchema(inputName, maxTextLength = 200) {
  const textTooLong = `Будь ласка, введіть запит довжиною до ${maxTextLength} символів.`;
  const validationSchema = yup.object({
    [inputName]: yup.string().max(maxTextLength, textTooLong)
  });

  return validationSchema;
}
